export default __webpack_public_path__ + "static/thumb-18-e867581aea062097c642303e98cd462a.jpg";